import WarningErrorIcon from '@/assets/icons/WarningErrorIcon';
import { LoadingButton } from '@mui/lab';
import {
    Box,
    Button,
    Dialog,
    Stack,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { useDeleteApiKey } from '../hooks';

CaktoApiConfirmationDialogDelete.propTypes = {
    open: PropTypes.bool.isRequired,
    handleCloseDialog: PropTypes.func.isRequired,
    apiKeyId: PropTypes.string.isRequired,
    currentPage: PropTypes.number.isRequired,
    resultsCount: PropTypes.number.isRequired,
    onPageDecrement: PropTypes.func.isRequired,
}

export default function CaktoApiConfirmationDialogDelete({
    open,
    handleCloseDialog,
    apiKeyId,
    currentPage,
    resultsCount,
    onPageDecrement
}) {

    const { deleteApiKeyAsync, isDeleting } = useDeleteApiKey(currentPage, resultsCount);

    const onDeleteApikey = async () => {
        try {
            const willPageBeEmpty = resultsCount <= 1;
            const isNotFirstPage = currentPage > 1;

            if (willPageBeEmpty && isNotFirstPage) {
                onPageDecrement();
            }

            await new Promise(resolve => setTimeout(resolve, 50));

            await deleteApiKeyAsync(apiKeyId);

            handleCloseDialog();
        } catch (error) {
            console.error('Erro ao deletar:', error);
        }
    };

    // Clique fora e Esc seguem o "Cancelar": com a exclusão em andamento, o diálogo fica até o
    // resultado chegar, para a lista não ficar sem saber se a chave saiu.
    const handleDialogClose = () => {
        if (isDeleting) return;
        handleCloseDialog();
    };

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={handleDialogClose}>
            <Stack justifyContent='center' alignItems='center' sx={{ bgcolor: 'background.default', height: 274 }} gap={2}>

                <WarningErrorIcon sx={{ width: 40, height: 40 }} />

                <Stack textAlign='center'>
                    <Typography variant="h5">Tem certeza que deseja excluir esta chave?</Typography>
                    <Typography variant="body2" color='text.secondary'>Essa ação é irreversível e poderá interromper integrações ativas.</Typography>
                </Stack>

                <Box display='flex' gap={1} justifyContent='center' >
                    <Button disabled={isDeleting} onClick={handleCloseDialog} variant='outlined' color='inherit'>
                        Cancelar
                    </Button>
                    <LoadingButton onClick={onDeleteApikey} disabled={isDeleting} loading={isDeleting} variant='contained' color='error'>
                        Excluir
                    </LoadingButton>
                </Box>
            </Stack>


        </Dialog>
    )
}